import { Error, ErrorConnector, HelpText, Input, Label, RequiredStar } from "../common";
import React from "react";
import { SharedInputProps } from "../Input";
import styled from "styled-components";
export type EmailProps = SharedInputProps;
export function Email({
  label,
  helpText,
  error,
  ...props
}: EmailProps) {
  const {
    id,
    required
  } = props;
  const hasError = !!error;
  return <>
      <Label htmlFor={id} data-sentry-element="Label" data-sentry-source-file="Email.tsx">
        {label}
        {required ? <RequiredStar /> : null}
      </Label>
      <HelpText data-sentry-element="HelpText" data-sentry-source-file="Email.tsx">{helpText}</HelpText>
      <Container data-sentry-element="Container" data-sentry-source-file="Email.tsx">
        <ErrorConnector show={hasError} data-sentry-element="ErrorConnector" data-sentry-source-file="Email.tsx">
          <Input type="email" error={hasError} aria-required={required} {...props} data-sentry-element="Input" data-sentry-source-file="Email.tsx" />
          {error ? <Error>{error}</Error> : null}
        </ErrorConnector>
      </Container>
    </>;
}
const Container = styled.div`
  width: 100%;
`;
export default Email;